import { render, staticRenderFns } from "./privacy-select.vue?vue&type=template&id=4b51982b&scoped=true&"
import script from "./privacy-select.vue?vue&type=script&lang=js&"
export * from "./privacy-select.vue?vue&type=script&lang=js&"
import style0 from "./privacy-select.vue?vue&type=style&index=0&id=4b51982b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51982b",
  null
  
)

export default component.exports